import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPdb = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18 3C18.4304 3 18.8126 3.27543 18.9487 3.68377L19.3442 4.87022H20C20.5523 4.87022 21 5.31794 21 5.87022V17.8702C21 18.4225 20.5523 18.8702 20 18.8702H4C3.44772 18.8702 3 18.4225 3 17.8702V5.87022C3 5.31794 3.44772 4.87022 4 4.87022H13.5083C13.572 4.37925 13.9917 4 14.5 4C15.0083 4 15.428 4.37925 15.4917 4.87022H16.6558L17.0513 3.68377C17.1874 3.27543 17.5696 3 18 3ZM5 6.87022V16.8702H11V6.87022H5ZM13 6.87022V16.8702H19V6.87022H13Z",
		fill: "currentColor"
	})
});
export default SvgPdb;
